/*** Loading animation ***/
import lottie from 'lottie-web'

function startLodaingAnimation() {
    let loadingPageAnim = lottie.loadAnimation({
        container: document.getElementById('mp-loading'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: '/anim-data/loading-short.json',
    });
    loadingPageAnim.setSpeed(1.3);
    // loadingPageAnim.setSpeed(30);
    loadingPageAnim.onComplete = function () {
        let el = document.getElementById('mp-loading')
        el.style.opacity = 0;
        document.documentElement.style.overflow = 'auto';
        document.documentElement.style.height = 'auto';
        document.documentElement.style.width = 'auto';
        setTimeout(()=>{
            this.destroy();
            el.remove();
        }, 600);
    }
}


/*** Main App ***/
import Vue from 'vue'

import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
import { csrfUpdater } from './tools/ajaxDataMiddlewares'
axios.interceptors.response.use(function (response) { // http status == 2xx
    csrfUpdater(response.data);
    return response;
}, function (error) { // http status != 2xx
    if(error.response.status === 419){
        window.location.reload();
    }
    return Promise.reject(error);
});

import VueRouter from 'vue-router'
import routes from  './routes'
import {redirect} from  './routes'
Vue.use(VueRouter)
const router = new VueRouter({
    routes
})

import { MqttClient } from './mqttClient'
Vue.prototype.$mqtt = new MqttClient()

import Vuex from 'vuex'
Vue.use(Vuex)
import store from './store'

import mainApp from './vue-components/mainApp.vue'
import {mapState} from 'vuex'

import { devApi, objPropsFromCmdVals, cmdVals, propsGetOnly } from './api/device'
import { DEV_UPDATE_PROP, MQTT_CONNECTED_SET } from './store/muations'

const vueApp = new Vue({
    router,
    components:{
        mainApp,
    },
    el: '#vueApp',
    store,
    computed:{
        ...mapState([
            'loggedIn',
            // 'user',
        ])
    },
    watch:{
        loggedIn(newVal, oldVal){
            let r = redirect(this.$route, newVal);
            if(r !== false) this.$router.push(r);

            if(newVal === true){
                this.$store.dispatch('loadUserData').then(()=>{
                    let mu = this.$store.state.mqttUser;
                    this.$mqtt.connect(mu.username, mu.password_visible, (connected)=>{
                        this.$store.commit(MQTT_CONNECTED_SET, connected)
                    })
                    // подписка на апдейт состояний всех девайсов юзера
                    let devs = this.$store.state.devs.all
                    if(devs) _.forEach(devs, (dev)=>{
                        devApi.mqttCtrl.subsToStates(this.$mqtt, dev, (actionVal, msgVal)=>{
                            this.$store.commit(DEV_UPDATE_PROP, {
                                devId: dev.id,
                                prop: objPropsFromCmdVals[cmdVals[actionVal]] || propsGetOnly[actionVal],
                                val: msgVal
                            })
                        })
                    })

                    // редирект на 1й объект и девайс, если маршрут был building
                    if(this.$route.name === 'building'){
                        _.each(this.$store.state.buildings.all, (b) => {
                            if(!b.demo){
                                let devs = b.zones[0].device_ids; // т.к. зона только 1, то берем ее
                                if(devs && devs.length){
                                    let d = this.$store.state.devs.all[devs[0]];
                                    // если есть девайсы, то берем 1й же и переходим на него
                                    if(d) this.$router.push({ name: 'device', params: { buildingId: b.id, devId: d.id }})
                                }
                            }
                        })
                    }
                })
            }
        }
    },
    created(){
        startLodaingAnimation();
        // переход на нужные маршруты в зависимости от авторизованности
        this.$store.dispatch('getAuthUser').then(()=>{
            let r = redirect(this.$route, this.loggedIn);
            if(r !== false) this.$router.push(r);
        });
        this.$router.beforeEach((to, from, next) => {
            let p = redirect(to, this.loggedIn);
            if(p !== false){
                next(p)
            } else {
                next()
            }
        })
    }
})
